import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import {
  GITHUB_CODING_AGENT_CONTEXT_STORAGE_KEY,
  GITHUB_QUERY_PARAMS,
} from '@fly/shared';
import { FlyNotFound } from '@fly/shared-ui';

const GITHUB_HTTPS_PREFIX = 'https://github.com/';

function isAllowedGitHubTarget(url: string | null): url is string {
  return url !== null && url.startsWith(GITHUB_HTTPS_PREFIX);
}

export function GitHubConfigureRedirect() {
  const [searchParams] = useSearchParams();
  const codingAgent = searchParams.get(GITHUB_QUERY_PARAMS.CODING_AGENT);
  const returnProtocol = searchParams.get(GITHUB_QUERY_PARAMS.RETURN_PROTOCOL);
  const target = searchParams.get(GITHUB_QUERY_PARAMS.TARGET);

  useEffect(() => {
    if (!isAllowedGitHubTarget(target)) {
      return;
    }

    const payload: Record<string, string> = {};
    if (codingAgent) {
      payload[GITHUB_QUERY_PARAMS.CODING_AGENT] = codingAgent;
    }
    if (returnProtocol) {
      payload[GITHUB_QUERY_PARAMS.RETURN_PROTOCOL] = returnProtocol;
    }
    try {
      if (Object.keys(payload).length > 0) {
        sessionStorage.setItem(
          GITHUB_CODING_AGENT_CONTEXT_STORAGE_KEY,
          JSON.stringify(payload)
        );
      }
    } catch {
      // Graceful degradation — storage unavailable (disabled or quota exceeded).
      // Redirect still happens; callback page won't show "Continue in <agent>" prompt.
    }

    window.location.replace(target);
  }, [target, codingAgent, returnProtocol]);

  if (!isAllowedGitHubTarget(target)) {
    return <FlyNotFound />;
  }

  return null;
}
